/**************************************************************
 Copyright © Sogu Technologies Co. Ltd 2018-2050 All rights reserved.
 File name: footer
 Author: HuangJun
 Description: 页面底部
 Others: 
 History: 
     1.Date:
       Author: 
       Modification:
*******************************************************************/
<template>
  <div>
    <div class="footer flex align-item-center ">
      <img class="footer_logo" src="../assets/img/footer_logo.png" alt />
      <p class="copyright">上海微星网络科技有限公司 &nbsp;&nbsp;&nbsp;&nbsp;ICP备案号: <a href="https://beian.miit.gov.cn/?spm=5176.13841030.J_9220772140.116.71fe6fc4nMG2YY#/Integrated/index" target="_blank" rel="noopener noreferrer">沪ICP备18007066号-6</a></p>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {};
  },
  mounted: function() {},
  computed: {},
  methods: {
    
  }
};
</script>



// WEBPACK FOOTER //
// src/components/footer.vue